import { BrowserRouter } from 'react-router-dom'
import { AuthProvider } from '../features/auth/AuthContext'
import { NotificationOnboarding } from '../features/notifications/NotificationOnboarding'
import { PwaInstallHint } from '../features/pwa/PwaInstallHint'
import { AppRoutes } from './AppRoutes'

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
        <NotificationOnboarding />
        <PwaInstallHint />
      </AuthProvider>
    </BrowserRouter>
  )
}

export default App
